/**
 * @generated SignedSource<<cfc35e4a457fe61de0c30732064a5e45>>
 * @relayHash 69db80da238fddc9efc05e1f0d3874bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d97fd6bcd92e40c400f1d0195b0857711f82628258f28f3e68be578fd586294c

import type { ConcreteRequest, Query } from 'relay-runtime';
export type tenantContextProviderQuery$variables = {
  hostNames?: ReadonlyArray<string> | null | undefined;
};
export type tenantContextProviderQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly active: string | null | undefined;
    } | null | undefined;
    readonly cloudId: string;
    readonly entitlementInfo: {
      readonly entitlementId: string;
    } | null | undefined;
    readonly orgId: string;
  } | null | undefined>;
};
export type tenantContextProviderQuery = {
  response: tenantContextProviderQuery$data;
  variables: tenantContextProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hostNames"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "hostNames",
    "variableName": "hostNames"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "cloudId"
},
v3 = {
  "kind": "ScalarField",
  "name": "orgId"
},
v4 = {
  "args": [
    {
      "kind": "Literal",
      "name": "product",
      "value": "devai"
    }
  ],
  "concreteType": "TenantContextActivationId",
  "kind": "LinkedField",
  "name": "activationIdByProduct",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "active"
    }
  ],
  "storageKey": "activationIdByProduct(product:\"devai\")"
},
v5 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "devai.ondemand"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "entitlementId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "tenantContextProviderQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "TenantContext",
          "kind": "LinkedField",
          "name": "tenantContexts",
          "plural": true,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v2/*: any*/),
              "action": "THROW",
              "path": "tenantContexts.cloudId"
            },
            {
              "kind": "RequiredField",
              "field": (v3/*: any*/),
              "action": "THROW",
              "path": "tenantContexts.orgId"
            },
            (v4/*: any*/),
            {
              "args": (v5/*: any*/),
              "kind": "LinkedField",
              "name": "entitlementInfo",
              "plural": false,
              "selections": [
                (v6/*: any*/)
              ],
              "storageKey": "entitlementInfo(hamsProductKey:\"devai.ondemand\")"
            }
          ]
        },
        "action": "THROW",
        "path": "tenantContexts"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tenantContextProviderQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v6/*: any*/)
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"devai.ondemand\")"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d97fd6bcd92e40c400f1d0195b0857711f82628258f28f3e68be578fd586294c",
    "metadata": {},
    "name": "tenantContextProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1cafadc9ec0ee54cfbfa8c70972bc134";

export default node;
